import Actions          from "../../model/constant/actions"
import ReducerUtils     from "../../utils/ReducerUtils"

export const FetchingWebLeads = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_WEB_LEADS_OF_ACCOUNT]  : ()=>true,
  [Actions.RETRIEVE_WEB_LEADS_OF_ACCOUNT]    : ()=>false,
  [Actions.CHANGE_SELECTED_PERIOD]           : ()=>false,
  [Actions.MODIFY_SELECTED_ACCOUNTS_BY_LIST] : ()=>false,
})
